import React from 'react';
import cn from 'clsx';

import Button from '../../../../library/button/button';
import { SlidersRegularIcon } from '../../../../shared/icons/icons';

import styles from './filter-button.scss';

interface FilterButtonProps {
  className?: string;
  filterCount: number;
  onToggleMobileFilter?: () => void;
}

function FilterButton(props: FilterButtonProps) {
  const { className, filterCount, onToggleMobileFilter } = props;

  return (
    <Button
      className={cn(styles['filter-button'], className)}
      isSecondary
      onClick={onToggleMobileFilter}
    >
      <SlidersRegularIcon className={styles['filter-button-icon']} />
      filters
      {!isNaN(filterCount) && filterCount > 0 && (
        <span className={styles['filter-button-count']}>({filterCount})</span>
      )}
    </Button>
  );
}

export default FilterButton;
